import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class LiabilityShareOwnershipType extends Enum {
  key!: string;
  value!: string;
  description!: string;

  static SOLE: LiabilityShareOwnershipType = {
    key: 'sole',
    get value() {
      return Lang.t('liability.sole');
    },
    get description() {
      return Lang.t('liability.deceased-only-responsible');
    }
  };

  static JOINT: LiabilityShareOwnershipType = {
    key: 'joint',
    get value() {
      return Lang.t('asset.joint');
    },
    get description() {
      return Lang.t('liability.deceased-shared-responsibility');
    }
  };

  static JOINT_WITH_SURVIVORSHIP_RIGHT: LiabilityShareOwnershipType = {
    key: 'joint_with_survivorship_right',
    get value() {
      return Lang.t('asset.joint-of-survivorship');
    },
    get description() {
      return Lang.t('liability.automatically-to-co');
    }
  };
}
